import { Routes } from '@angular/router';
import { CompanySettingsComponent } from './pages/companysettings/companysettings.component';
import { UserSettingsComponent } from './pages/user-settings/user-settings.component';
import { SocialAiComponent } from './pages/social-ai/social-ai.component';
import { CompanyComponent } from './pages/company/company.component';
import { UserComponent } from './pages/user/user.component';
import { SocialAiSettingsComponent } from './pages/social-ai-settings/social-ai-settings.component';
import { SocialAiPlatformsComponent } from './pages/social-ai-platforms/social-ai-platforms.component';
import { AdminSocialAiComponent } from './pages/admin-social-ai/admin-social-ai.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { roleGuard } from './guards/auth.guard';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { SocialAiListOfPostsComponent } from './pages/social-ai-list-of-posts/social-ai-list-of-posts.component';
import { SocialAiUploadBulkComponent } from './pages/upload-bulk/social-ai-upload-bulk/social-ai-upload-bulk.component';
import { SocialAiListOfBulkPostsTableComponent } from './components/tables/social-ai-list-of-bulk-posts-table/social-ai-list-of-bulk-posts-table.component';
import { SocialAiListOfRepeatPostsTableComponent } from './components/tables/social-ai-list-of-repeat-posts-table/social-ai-list-of-repeat-posts-table.component';
import { SocialAiRepeatPostFormComponent } from './components/forms/social-ai-repeat-post-form/social-ai-repeat-post-form.component';
import { SocialAiPreviewComponent } from './pages/social-ai-preview/social-ai-preview.component';
import { DownloadImageComponent } from './pages/download-image/download-image.component';
import { SocialAiReuseComponent } from './pages/social-ai-reuse/social-ai-reuse.component';
import { SocialAiDashboardComponent } from './pages/social-ai-dashboard/social-ai-dashboard.component';
import { SocialAiEditPostFormComponent } from './components/forms/social-ai-edit-post-form/social-ai-edit-post-form.component';
import { SocialAiCreatePostFormComponent } from './components/forms/social-ai-create-post-form/social-ai-create-post-form.component';
import { GridBasedLayoutComponent } from './components/tables/grid-based-layout/grid-based-layout.component';
import { LoginComponent } from './components/forms/login/login.component';
import { NewdashComponent } from './components/tables/newdash/newdash.component';
import { BaseLayoutComponent } from './components/tables/base-layout/base-layout.component';
import { SocialAiChartComponent } from './components/tables/social-ai-chart/social-ai-chart.component';
import { FacebookTokenPageComponent } from './components/tables/facebook-token-page/facebook-token-page.component';
import { SocialAiReportsTabComponent } from './pages/social-ai-reports-tab/social-ai-reports-tab.component';
import { SocialAiReportsChartComponent } from './components/tables/social-ai-reports-chart/social-ai-reports-chart.component';
import { FacebookPhotopostComponent } from './pages/manage-preview/facebook-photopost/facebook-photopost.component';
import { InstagramPhotopostComponent } from './pages/manage-preview/instagram-photopost/instagram-photopost.component';
import { TikTokVideopostComponent } from './pages/manage-preview/tiktok-videopost/tiktok-videopost.component';
import { QueryBuilderComponent } from './pages/query-builder/query-builder.component'
import { PreviewTestComponent } from './pages/preview-test/preview-test.component';

// manage-account pages
// =============================================================================================================
import { CreateCompanyComponent } from './pages/manage-account/create/create-company/create-company.component';
import { CreateUserComponent } from './pages/manage-account/create/create-user/create-user.component';
import { CreateSiteComponent } from './pages/manage-account/create/create-site/create-site.component';
import { CreatePlaformComponent } from './pages/manage-account/create/create-plaform/create-plaform.component';
import { CreateFeedComponent } from './pages/manage-account/create/create-feed/create-feed.component';
import { CreateVideoTemplateComponent } from './pages/manage-account/create/create-video-template/create-video-template.component';
import { CreatePricingPlanComponent } from './pages/manage-account/create/create-pricing-plan/create-pricing-plan.component';
import { CreateApproveComponent } from './pages/manage-account/create/create-approve/create-approve.component';
// ==============================================================================================================
import { EditUserComponent } from './pages/manage-account/edit/edit-user/edit-user.component';
import { EditSiteComponent } from './pages/manage-account/edit/edit-site/edit-site.component';
import { EditPlatformComponent } from './pages/manage-account/edit/edit-platform/edit-platform.component';
// ==============================================================================================================
import { SocialAiUploadImagesComponent } from './pages/upload-bulk/social-ai-upload-images/social-ai-upload-images.component';
import { SocialAiBulkResultsComponent } from './pages/upload-bulk/social-ai-bulk-results/social-ai-bulk-results.component';
import { IndexUsersComponent } from './pages/manage-account/index/index-users/index-users.component';
import { IndexPagesComponent } from './pages/manage-account/index/index-pages/index-pages.component';
import { IndexPlatformsComponent } from './pages/manage-account/index/index-platforms/index-platforms.component';
import { IndexFeedsComponent } from './pages/manage-account/index/index-feeds/index-feeds.component';

// other new pages
import { SocialAiDownloadFileComponent } from './pages/upload-bulk/social-ai-download-file/social-ai-download-file.component';
import { TikTokDashboardComponent } from './pages/tiktok/tik-tok-dashboard/tik-tok-dashboard.component';
import { LeonardoAiComponentOld } from './pages/leonardo/leonardo-ai-old/leonardo-ai.component';
import { DemoSignupComponent } from './pages/demo-signup/demo-signup.component';

import { ManageApplicationIndexAccountsComponent } from './pages/manage-application/index-accounts/index-accounts.component';
import { ManageApplicationIndexUsersComponent } from './pages/manage-application/index-users/index-users.component';
import { ManageApplicationIndexSitesComponent } from './pages/manage-application/index-sites/index-sites.component';
import { ManageApplicationIndexPlatformsComponent } from './pages/manage-application/index-platforms/index-platforms.component';
import { ManageApplicationIndexPostsComponent } from './pages/manage-application/index-posts/index-posts.component';



// ai-engine components
import { AiEngineNewContentComponent } from './pages/ai-engine/new-content/new-content.component';
import { AiEngineViewContentComponent } from './pages/ai-engine/view-content/view-content.component';

export const routes: Routes = [
  // { path: '', component: HomeComponent },
  { path: '', redirectTo: '/posts', pathMatch: 'full' },
  { path: 'user', component: UserComponent },
  { path: 'company', component: CompanyComponent },
  { path: 'social-ai', component: SocialAiSettingsComponent },
  { path: 'socialaiplatforms', component: SocialAiPlatformsComponent },
  { path: 'companysettings/:id', component: CompanySettingsComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'reuse-post/:id', component: SocialAiReuseComponent },
  { path: 'posts', component: SocialAiListOfPostsComponent },
  { path: 'bulk-upload', redirectTo: 'upload-bulk/social-ai-upload-images', pathMatch: 'full' },
  { path: 'upload-bulk/social-ai-upload-images', component: SocialAiUploadImagesComponent },
  { path: 'upload-bulk/social-ai-download-file', component: SocialAiDownloadFileComponent },
  { path: 'upload-bulk/social-ai-upload-bulk', component: SocialAiUploadBulkComponent },
  { path: 'upload-bulk/social-ai-bulk-results', component: SocialAiBulkResultsComponent },
  { path: 'upload-bulk/create-approve', component: CreateApproveComponent },

  { path: 'bulk-posts', component: SocialAiListOfBulkPostsTableComponent },
  { path: 'repeat-posts', component: SocialAiListOfRepeatPostsTableComponent },
  { path: 'repeat-post/:id', component: SocialAiRepeatPostFormComponent },
  { path: 'preview-post/:tag/:id', component: SocialAiPreviewComponent },
  { path: 'manage-preview/facebook-photopost/:company_id/:post_id', component: FacebookPhotopostComponent },
  { path: 'manage-preview/instagram-photopost/:id', component: InstagramPhotopostComponent },
  { path: 'manage-preview/tiktok-videopost', component: TikTokVideopostComponent },
  { path: 'download-image', component: DownloadImageComponent },
  { path: 'preview-test/:tag/:id', component: PreviewTestComponent },
  { path: 'dashboard/query-builder', component: QueryBuilderComponent },
  { path: 'reports-metrics', component: SocialAiReportsTabComponent },
  { path: 'fb-token', component: FacebookTokenPageComponent },
  { path: 'page-metrics', component: SocialAiReportsChartComponent },

  // manage-account components
  { path: 'manage-account/create-company', component: CreateCompanyComponent },
  { path: 'manage-account/create-user/:company', component: CreateUserComponent },
  { path: 'manage-account/create-site/:company', component: CreateSiteComponent },
  { path: 'manage-account/create-platform/:company/:site', component: CreatePlaformComponent },
  { path: 'manage-account/create-feed/:company/:site', component: CreateFeedComponent },
  { path: 'manage-account/create-video-template/:company/:site', component: CreateVideoTemplateComponent },
  { path: 'manage-account/create-pricing-plan/:company', component: CreatePricingPlanComponent },
  { path: 'manage-account/create-approve/:company', component: CreateApproveComponent },

  { path: 'manage-account/edit-user/:user', component: EditUserComponent },
  { path: 'manage-account/edit-site/:site', component: EditSiteComponent },
  { path: 'manage-account/edit-platform/:platform', component: EditPlatformComponent },

  { path: 'manage-account/index-users/:company', component: IndexUsersComponent },
  { path: 'manage-account/index-pages/:company', component: IndexPagesComponent },
  { path: 'manage-account/index-platforms/:company', component: IndexPlatformsComponent },
  { path: 'manage-account/index-feeds/:company', component: IndexFeedsComponent },
  { path: 'leonardo-ai/old', component: LeonardoAiComponentOld },

  { path: 'tik-tok', component: TikTokDashboardComponent },

  {
    path: 'dashboard',
    component: SocialAiDashboardComponent,
    children: [
      { path: '', redirectTo: 'followers', pathMatch: 'full' },
      { path: ':view', component: SocialAiChartComponent }
    ]
  },
  { path: 'login', component: LoginComponent },

  { path: 'new-dash', component: NewdashComponent },
  { path: 'base-layout', component: BaseLayoutComponent },
  { path: 'gridcomponent', component: GridBasedLayoutComponent },

  { path: 'edit-post/:id', component: SocialAiEditPostFormComponent },
  { path: 'create-post', component: SocialAiCreatePostFormComponent },

  {
    path: 'social-ai-admin',
    loadComponent: () => import('./pages/admin-social-ai/admin-social-ai.component').then(m => m.AdminSocialAiComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },
  { path: 'manage-application', redirectTo: 'manage-application/accounts', pathMatch: 'full' },
  { path: 'manage-application/accounts', component: ManageApplicationIndexAccountsComponent, canActivate: [roleGuard], data: { roles: ['Admin'] } },
  { path: 'manage-application/users', component: ManageApplicationIndexUsersComponent, canActivate: [roleGuard], data: { roles: ['Admin'] } },
  { path: 'manage-application/sites', component: ManageApplicationIndexSitesComponent, canActivate: [roleGuard], data: { roles: ['Admin'] } },
  { path: 'manage-application/platforms', component: ManageApplicationIndexPlatformsComponent, canActivate: [roleGuard], data: { roles: ['Admin'] } },
  { path: 'manage-application/posts', component: ManageApplicationIndexPostsComponent, canActivate: [roleGuard], data: { roles: ['Admin'] } },

  // ai-engine components
  { path: 'pages/ai-engine/new-content', component: AiEngineNewContentComponent },
  { path: 'pages/ai-engine/view-content', component: AiEngineViewContentComponent },
  
  { path: 'demo-signup', component: DemoSignupComponent },

  // PerceptionIQ
  {
    path: 'perception-iq/new-analysis',
    loadComponent: () =>
      import('./pages/perception-iq/new-analysis/new-analysis.component')
        .then(m => m.NewAnalysisComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'perception-iq/reports',
    loadComponent: () =>
      import('./pages/perception-iq/my-reports/my-reports.component')
        .then(m => m.PublioPerceptionIqMyReportsComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'perception-iq/analysis-in-progress',
    loadComponent: () =>
      import('./pages/perception-iq/analysis-in-progress/analysis-in-progress.component')
        .then(m => m.PublioPerceptionIqAnalysisInProgressComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'perception-iq',
    loadComponent: () =>
      import('./pages/perception-iq/perception-iq.component')
        .then(m => m.PublioPerceptionIqComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },
  {
    path: 'perception-iq/reports/:id',
    loadComponent: () =>
      import('./pages/perception-iq/report-details/report-details.component')
        .then(m => m.PublioPerceptionIqReportDetailsComponent),
    canActivate: [roleGuard],
    data: { roles: ['Admin'] }
  },

  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
  // { path: 'profile', component: UserSettingsComponent }
];
